// extracted by mini-css-extract-plugin
module.exports = {"select":"EditField_select__2dKNN"};